import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import PricingListResponseDto = Cloud.RavenDB.Core.Dto.Pricing.PricingListResponseDto;
import CalculatePriceRequestDto = Cloud.RavenDB.Core.Dto.Pricing.CalculatePriceRequestDto;
import CalculatePriceResponseDto = Cloud.RavenDB.Core.Dto.Pricing.CalculatePriceResponseDto;
import CalculateInternalPriceRequestDto = Cloud.RavenDB.Core.Dto.Pricing.CalculateInternalPriceRequestDto;
import CalculateInternalPriceResponseDto = Cloud.RavenDB.Core.Dto.Pricing.CalculateInternalPriceResponseDto;

export default class PricingService extends AbstractService {
    getPricing = async (): Promise<PricingListResponseDto> => {
        const pricing = await this.query<PricingListResponseDto>(ApiRoutes.pricing.getPricingList());
        return pricing.data;
    };

    calculatePrice = async (dto: CalculatePriceRequestDto) => {
        const results = await this.post<CalculatePriceRequestDto, CalculatePriceResponseDto>(
            ApiRoutes.pricing.calculatePrice(),
            dto
        );
        return results.data;
    };

    calculateInternalPrice = async (dto: CalculateInternalPriceRequestDto) => {
        const results = await this.post<CalculateInternalPriceRequestDto, CalculateInternalPriceResponseDto>(
            ApiRoutes.pricing.calculateInternalPrice(),
            dto
        );
        return results.data;
    };
}
